module.exports = __webpack_public_path__ + "img/fwdw_03.f305aecd.jpg";